@let status = this.form.controls.attesteringStatus.value;

@if(betalningsinformation$ | async; as betalningsInfo){
<h2>
    Befintlig betalningsinformation
</h2>

<div class="row">
    @if(betalningsInfo.betalningsmetod){
    <rask-textmultiline
        class="col-4"
        label="Betalningsmetod"
        [value]="getBetalningsmetodName(betalningsInfo.betalningsmetod)">
    </rask-textmultiline>
    }
    @if(betalningsInfo.clearingnummer){
    <rask-textmultiline
        class="col-4"
        label="clearingnummer"
        [value]="betalningsInfo.clearingnummer">
    </rask-textmultiline>
    }
    @if(betalningsInfo.bankkonto){
    <rask-textmultiline
        class="col-4"
        label="Bankkonto"
        [value]="betalningsInfo.bankkonto">
    </rask-textmultiline>
    }
    @if(betalningsInfo.bankgiro){
    <rask-textmultiline
        class="col-4"
        label="Bankgiro"
        [value]="betalningsInfo.bankgiro">
    </rask-textmultiline>
    }
    @if(betalningsInfo.postgiro){
    <rask-textmultiline
        class="col-4"
        label="Plusgiro"
        [value]="betalningsInfo.postgiro">
    </rask-textmultiline>
    }
    @if(betalningsInfo.iban){
    <rask-textmultiline
        class="col-4"
        label="Iban"
        [value]="betalningsInfo.iban">
    </rask-textmultiline>
    }
    @if(betalningsInfo.gln){
    <rask-textmultiline
        class="col-4"
        label="Gln"
        [value]="betalningsInfo.gln">
    </rask-textmultiline>
    }
    @if(betalningsInfo.bicSwift){
    <rask-textmultiline
        class="col-4"
        label="Bic/Swift"
        [value]="betalningsInfo.bicSwift">
    </rask-textmultiline>
    }
</div>
}

<br /><br />

<rask-toggle-panel
  label="Ny information för granskning"
  [defaultExpanded]="false"
>
    <ng-container>
        <form [formGroup]="form" [ngClass]="{skapad: status ==='Skapad'}">
            <div class="row">
                <rask-selector
                    class="col-4"
                    id="inputBetalningsmetod"
                    label="{{ 'LEVERANTOR_LABEL_BETALNINGSMETOD' | translate }}"
                    formControlName="betalningsmetod"
                    bindValue="id"
                    bindLabel="namn"
                    [values]="betalningsmetodValues">
                </rask-selector>
                @switch (form.controls.betalningsmetod.value) {
                @case ('Konto') {
                <rask-input
                    class="col-4"
                    label="Clearing (exakt 4 siffror)"
                    [placeholder]="1234"
                    formControlName="clearingnummer"
                    infoText="Clearingnummer är fyrställigt (vid fem siffror stryks sista siffran). Kontonummer skrivs utan punkter, mellanslag eller streck. Exempel: clearing 8452 kontonummer 123456781"
                    [maxlengthhide]="4">
                </rask-input>
                <rask-input
                    class="col-4"
                    label="{{ 'LEVERANTOR_LABEL_BANKKONTO' | translate }}"
                    formControlName="bankkonto"
                    [maxlengthhide]="20">
                </rask-input>
                }
                @case ('Bankgiro') {
                <rask-input
                    class="col-4"
                    label="{{ 'LEVERANTOR_LABEL_BANKGIRO' | translate }}"
                    formControlName="bankgiro"
                    [maxlengthhide]="30">
                </rask-input>
                }
                @case ('Postgiro') {
                <rask-input
                    class="col-4"
                    label="{{ 'LEVERANTOR_LABEL_PLUSGIRO' | translate }}"
                    formControlName="postgiro"
                    [maxlengthhide]="30">
                </rask-input>
                }
                }
            </div>

            <div class="row">
                <rask-input
                    class="col-4"
                    label="{{ 'LEVERANTOR_LABEL_GLN' | translate }}"
                    formControlName="gln"
                    [maxlengthhide]="40">
                </rask-input>

                <rask-input
                    class="col-4"
                    label="{{ 'LEVERANTOR_LABEL_IBAN' | translate }}"
                    formControlName="iban"
                    [maxlengthhide]="40">
                </rask-input>

                <rask-input
                    class="col-4"
                    label="{{ 'LEVERANTOR_LABEL_BIC_SWIFT' | translate }}"
                    formControlName="bicSwift"
                    [maxlengthhide]="40">
                </rask-input>

                <rask-textarea
                    class="col-12"
                    label="Callback notering"
                    formControlName="callbackNotering"
                    [placeholder]="noteringPlaceholder"
                    [minlength]="10"
                    [rows]="4">
                </rask-textarea>

                <rask-search
                    class="col-6"
                    label="Begär godkännande från"
                    bindLabel="namn"
                    formControlName="attesterasAv"
                    [typeaheadFn]="searchForAnsvarigPlanerareTypeAhead"
                    loadingText="Laddar..."
                    notFoundText="Ingen träff"
                    [minTermLength]="3"
                    [selected]="form.controls.attesterasAv.value">
                </rask-search>
            </div>
        </form>
    </ng-container>
</rask-toggle-panel>

<div class="row">
    <div class="col d-flex">
        @if(canEdit){
        <rask-button
            [disabled]="this.form.invalid || this.form.dirty || this.isLoading()"
            (click)="sendClickSrc.next()">
            <span>Skicka</span>
        </rask-button>
        }
        @else if (status === "Skickad") {
        @let attestDisabled = this.form.invalid || this.isLoading();
        @if(this.form.controls.isCreator.value){
        <rask-button
            color="secondary"
            [disabled]="this.isLoading()"
            (click)="deleteClickSrc.next()">
            Ta bort
        </rask-button>
        }
        @else{
        <rask-button
            [disabled]="attestDisabled"
            (click)="approveClickSrc.next()">
            Godkänn
        </rask-button>
        <rask-button
            [disabled]="attestDisabled"
            (click)="rejectClickSrc.next()">
            Avvisa
        </rask-button>
        }
        }
        @if(isSkapad){
        @let hasContent = icon.hasContent$ | async;
        <rask-icon
            #icon
            icon="far fa-circle-exclamation error"
            class="error-icon mt-auto"
            [ngClass]="{'d-none': !hasContent}"
            popoverClass="popover-error popover-no-max-width">
            @if(this.form.controls.betalningsmetod.hasError("required")){
            <div #popoverContent>Betalningsmetod är obligatoriskt</div>
            }
            @if(this.form.controls.bankgiro.hasError("required")){
            <div #popoverContent>Bankgiro är obligatoriskt</div>
            }
            @if(this.form.controls.postgiro.hasError("required")){
            <div #popoverContent>Postgiro är obligatoriskt</div>
            }
            @if(this.form.controls.bankkonto.hasError("required")){
            <div #popoverContent>Bankkonto är obligatoriskt</div>
            }
            @if(this.form.controls.clearingnummer.hasError("required")){
            <div #popoverContent>Clearingnummer är obligatoriskt</div>
            }
            @if(this.form.controls.callbackNotering.hasError("required")){
            <div #popoverContent>Callback notering är obligatoriskt</div>
            }
            @if(this.form.controls.attesterasAv.hasError("required")){
            <div #popoverContent>En köpledare måste väljas</div>
            }
            @if(this.form.controls.callbackNotering.hasError("minlength")){
            <div #popoverContent>Callback notering måste vara minst 10 tecken.</div>
            }
            @if(this.form.dirty){
            <div #popoverContent>Spara för att kunna skicka</div>
            }
        </rask-icon>
        }
        @if(this.isLoading()){
        <div class="d-flex">
            <rask-busy-spinner class="mt-auto"></rask-busy-spinner>
        </div>
        }
    </div>
</div>